"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableAction = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var button_1 = require("../../../elements/button/button");
var button_type_1 = require("../../../elements/button/button-type");
var table_action_style_1 = require("./table-action-style");
function TableAction(props) {
    var actions = props.actions, rowIndex = props.rowIndex, row = props.row, restProps = __rest(props, ["actions", "rowIndex", "row"]);
    if (!actions) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(table_action_style_1.StyledTableAction, __assign({}, restProps, { children: actions.map(function (action, actionIndex) {
            var text = action.text, _a = action.size, size = _a === void 0 ? button_type_1.ButtonSize.XX_SMALL : _a, color = action.color, variant = action.variant, href = action.href, onClick = action.onClick;
            return ((0, jsx_runtime_1.jsx)(button_1.Button, { size: size, color: color, variant: variant, href: href, onClick: function () {
                    onClick === null || onClick === void 0 ? void 0 : onClick(rowIndex, row);
                }, children: text }, actionIndex));
        }) })));
}
exports.TableAction = TableAction;
